/**
 * firmaUyruk.js — Firma uyruğu (Yerli / Yabancı) ile ülkesinin ortak kuralları (backlog #554).
 *
 * Üç form kullanır: Yeni Firma (CreateFirmaModal), Firma Bilgilerini Düzenle (FirmaBilgileriDuzenleModal, personel kipi) ve
 * onların ülke seçicisi (UlkeSecici). Kural backend'inkiyle aynı (FirmaService.applyFirmaNationRule): ülke Türkiye (190) ise
 * firma her zaman Yerli'dir; yani Yerli = Türkiye, Yabancı = Türkiye dışında bir ülke. `country_id` 0 country tablosunda satır
 * değildir ama dev'deki ~23 bin firmada durur ("ülkesi bilinmiyor", UNKNOWN_COUNTRY_ID): seçicide açık bir "Bilinmiyor" seçeneği
 * olarak gösterilir, boş kutu olarak değil.
 */
import { FIRMA_NATION, TURKIYE_COUNTRY_ID, UNKNOWN_COUNTRY_ID } from "../../services/firmaAramaService";

/**
 * Uyruk değişince yeni ülke. Yerli → Türkiye. Yabancı'ya geçerken Türkiye'de kalınamaz (backend 190'ı Yerli'ye çevirir) →
 * Bilinmiyor; zaten başka bir ülke seçiliyse o korunur.
 */
export function uyrukDegisinceUlke(mevcutUlkeId, yeniNation) {
  if (Number(yeniNation) === FIRMA_NATION.YERLI) return TURKIYE_COUNTRY_ID;
  const mevcut = Number(mevcutUlkeId) || UNKNOWN_COUNTRY_ID;
  return mevcut === TURKIYE_COUNTRY_ID ? UNKNOWN_COUNTRY_ID : mevcut;
}

/**
 * Seçici seçenekleri: [{ value, label }]. "Bilinmiyor" başta; ardından GET /portal/ulkeler'in sırası (backend gösterilen
 * ada göre sıralı verir). turkiyeHaric: Yabancı için Türkiye seçilemez (Türkiye = Yerli, uyruk kutusundan seçilir).
 */
export function ulkeSecenekleri(ulkeler, bilinmiyorEtiketi, { turkiyeHaric = false } = {}) {
  const liste = (Array.isArray(ulkeler) ? ulkeler : [])
    .filter((u) => u && u.countryId != null
      && Number(u.countryId) !== UNKNOWN_COUNTRY_ID
      && !(turkiyeHaric && Number(u.countryId) === TURKIYE_COUNTRY_ID))
    .map((u) => ({ value: Number(u.countryId), label: u.countryName || `#${u.countryId}` }));
  return [{ value: UNKNOWN_COUNTRY_ID, label: bilinmiyorEtiketi }, ...liste];
}

/** Seçili değerin seçenek nesnesi; listede yoksa (liste okunamadı, silinmiş kayıt) boş kutu yerine "#id". */
export function secilenUlke(secenekler, ulkeId) {
  if (ulkeId == null || ulkeId === "") return null;
  const id = Number(ulkeId);
  if (!Number.isFinite(id)) return null;
  return secenekler.find((o) => o.value === id) ?? { value: id, label: `#${id}` };
}

/** Düzenleme formunun açılıştaki uyruğu ve ülkesi (profile-page'in firmaNation / countryId alanları). */
export function baslangicUyruk(profile, yabanciVarsayilan = false) {
  const firmaNation = Number(profile?.firmaNation) || (yabanciVarsayilan ? FIRMA_NATION.YABANCI : FIRMA_NATION.YERLI);
  const ulke = profile?.countryId;
  const countryId = ulke == null ? uyrukDegisinceUlke(UNKNOWN_COUNTRY_ID, firmaNation) : Number(ulke);
  return { firmaNation, countryId };
}

/**
 * PUT /firma/{id} gövdesine eklenecek uyruk alanları. Backend PATCH: anahtar yoksa kayıtlı değer korunur, yani değişmeyen
 * firmanın (ör. ülkesi 0 olan bir Yerli firma) ülkesine dokunmayız. Biri değiştiyse İKİSİ birlikte gider.
 */
export function uyrukGovdesi(onceki, simdi) {
  const ayni = Number(onceki?.firmaNation) === Number(simdi?.firmaNation)
    && Number(onceki?.countryId) === Number(simdi?.countryId);
  if (ayni) return {};
  return { firmaNation: Number(simdi.firmaNation), countryId: Number(simdi.countryId) };
}
